import { memo } from 'react';

import Text from '@modules/common/components/text';

import type { OrderDetailData } from './types';
import CheckoutFormItem from './checkout-form-item';
import PaymentSection from './payment-section';

interface OrderInfoProps {
  order: OrderDetailData;
}

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-TW', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

const OrderInfo = ({ order }: OrderInfoProps) => {
  const metadata = order.metadata;
  const buyerName = metadata?.buyer_name ?? '-';
  const buyerPhone = metadata?.buyer_phone ?? '-';
  const remark = metadata?.remark ?? null;
  const marxPayment = order.marxPayment;

  return (
    <div className="border-white-40 bg-white-20 flex-1 rounded-md border p-6">
      <Text variant="title-bold" as="h4" className="mb-4">訂單資訊</Text>
      <div className="flex flex-col gap-4">
        <CheckoutFormItem
          title="訂單成立日期"
          value={formatDate(String(order.created_at))}
        />
        <CheckoutFormItem title="訂購人姓名" value={buyerName} />
        <CheckoutFormItem title="聯絡電話" value={buyerPhone} />
        <CheckoutFormItem title="訂單備註" value={remark} />
        {marxPayment && (
          <PaymentSection payment={marxPayment} />
        )}
      </div>
    </div>
  );
};

export default memo(OrderInfo);
